import { Y42FeatureTypeToLogo } from '@y42/feature';
import { errorIcon } from '@y42/feature/icons';
import { leftColorStrip, roundedRightRectangle } from '@y42/gojs';
import { warningIcon } from '@y42/icons';
import { Y42FeatureType } from '@y42/json-schema';
import { Binding, GraphObject, Margin, Node, Panel, Picture, Point, Size, Spot, TextBlock } from 'gojs';
import {
  dataLineageDiagramConfig,
  DataLineageNodeBinding,
  DataLineageUINode,
  LINEAGE_PARTS,
} from '../../../../../state/data-lineage-diagram';
import { groupBackgroundBinding } from '../group/utils/bindings';
import { lineageRedirectButton } from '../shared/parts/buttons/lineage-redirect-button';
import { subEntityTypeLogoTooltip } from '../shared/parts/tooltips';
import {
  colorStripColorBinding,
  colorStripSizeBinding,
  isLayoutPositionedBinding,
  locationBinding,
  nameTextBinding,
  nameTextStrokeBinding,
  visibleBinding,
} from '../shared/utils/shared-bindings';
import { nodeStrokeBinding } from './utils/bindings';
import { nodeMouseHover, nodeMouseLeave } from './utils/events';

const $ = GraphObject.make;

export const widgetNodeTemplate = () =>
  $(
    Node,
    Node.Spot,
    {
      isShadowed: true,
      shadowColor: dataLineageDiagramConfig.colors.group.shadow,
      shadowOffset: new Point(0, 5),
      shadowBlur: 15,
      selectionAdorned: false,
      cursor: 'pointer',
      deletable: false,
      mouseHover: nodeMouseHover,
      mouseLeave: nodeMouseLeave,
    },

    // Bindings
    locationBinding(),
    isLayoutPositionedBinding(),

    // Parts
    $(
      Panel,
      Panel.Horizontal,
      leftColorStrip({}, [colorStripSizeBinding(), colorStripColorBinding()]),
      mainNodePanel(roundedRightRectangle({}, [nodeStrokeBinding(), groupBackgroundBinding()]), contentPanel()),
    ),
  );

const mainNodePanel = (...children: GraphObject[]) =>
  $(
    Panel,
    Panel.Auto,
    {
      defaultAlignment: Spot.Left,
      cursor: 'pointer',
    },
    ...children,
  );

const contentPanel = () =>
  $(
    Panel,
    Panel.Horizontal,
    {
      padding: new Margin(15, 5),
      alignment: Spot.Left,
      width: 320,
      height: 50,
    },
    widgetLogo(),
    textBlock(),
    lineageRedirectButton([visibleBinding(DataLineageNodeBinding.Name)]),
  );

const widgetLogo = (bindings: Binding[] = []) =>
  $(
    Picture,
    {
      name: LINEAGE_PARTS.NODE_LOGO_NAME,
      desiredSize: new Size(25, 25),
      imageStretch: GraphObject.Uniform,
      margin: new Margin(0, 10),
      toolTip: subEntityTypeLogoTooltip(),
    },
    widgetLogoBinding(),
    ...bindings,
  );

const widgetLogoBinding = () =>
  new Binding('source', '', (node: DataLineageUINode) => {
    return node[DataLineageNodeBinding.DeletedEntity]
      ? errorIcon
      : !node[DataLineageNodeBinding.HasReadPermission]
      ? warningIcon
      : Y42FeatureTypeToLogo[Y42FeatureType.VisualizationWidget];
  });

const textBlock = () =>
  $(
    TextBlock,
    {
      name: LINEAGE_PARTS.NODE_HEADER_NAME,
      overflow: TextBlock.OverflowEllipsis,
      margin: new Margin(0, 5),
      alignment: Spot.Left,
      font: `${dataLineageDiagramConfig.font.style} ${dataLineageDiagramConfig.font.size.big} ${dataLineageDiagramConfig.font.family}`,
      width: 230,
    },
    nameTextBinding(),
    nameTextStrokeBinding(),
  );
